import { render, staticRenderFns } from "./VueDataTable.vue?vue&type=template&id=36d64aa2&"
import script from "./VueDataTable.vue?vue&type=script&lang=js&"
export * from "./VueDataTable.vue?vue&type=script&lang=js&"
import style0 from "./VueDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d64aa2')) {
      api.createRecord('36d64aa2', component.options)
    } else {
      api.reload('36d64aa2', component.options)
    }
    module.hot.accept("./VueDataTable.vue?vue&type=template&id=36d64aa2&", function () {
      api.rerender('36d64aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/VueDataTable.vue"
export default component.exports